import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.payment}billing/${COMMON_QUERY_PARAMS.BILLING_ID}/creditNote`;

interface CreateCreditNoteCommandArgs {
  billingId: string;
}

const createCreditNoteCommand = async (
  payload: CreateCreditNoteCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  const url = ENDPOINT.replace(
    COMMON_QUERY_PARAMS.BILLING_ID,
    payload.billingId,
  );

  try {
    return await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.POST,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default createCreditNoteCommand;
